import { useEffect, useState } from "react";
import { getBotStates } from "../../../services/auth";

export default function useBotStates() {
  const [isLoading, setIsLoading] = useState(true);
  const [bots, setBots] = useState([]);

  const fetchData = async () => {
    const data = await getBotStates();
    if (data) {
      setBots(data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);
  return {
    isLoading,
    bots,
  };
}
